import { PublicClientApplication } from "@azure/msal-browser";
import { APIHeader, createErrorResponse } from "../Helpers";
import { msalConfig } from "../authConfig";
const url = process.env.REACT_APP_API_URL;

const getAccessToken = async () => {
  const pca = new PublicClientApplication(msalConfig);
  const accounts = pca.getAllAccounts();
  if (accounts.length > 0) {
      const request = {
          scopes: [
            `https://${process.env.REACT_APP_TENANT_NAME}.onmicrosoft.com/api/full`,
            "openid"
          ],
          account: accounts[0]
      };
      const accessToken = await pca.acquireTokenSilent(request).then((response) => {
          return response.accessToken;
      }).catch(error => {
          // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
          console.log(error);
          return null;
      });

      return accessToken;
  }

  return null;
};

const getAuthToken = async () => {
  try {
    const token = await getAccessToken() as any;
    return token;
  }
  catch (error: any) {
    createErrorResponse("Error", "Caught error while attempting to get Access token", undefined , "getAccessToken", undefined, error.status, "GET", error);
  }
};

const getUser = async () => {
  try {
    const pca = new PublicClientApplication(msalConfig);
    const accounts = pca.getAllAccounts();
    const user = {} as any;
    user.name = "Guest";
    if (accounts && accounts[0] && accounts[0].idTokenClaims) {
      const azureUserAccount = accounts[0].idTokenClaims as any;
      user.id = azureUserAccount.sub;
      user.email = (azureUserAccount.emails && azureUserAccount.emails.length > 0) && azureUserAccount.emails[0];
      user.mobilePhone = azureUserAccount.extension_MobilePhone;
    }
    
    return user;
  }
  catch (error: any) {
    createErrorResponse("Error", "Caught error while trying to get Id Token", undefined , "getIdToken", undefined, error.status, "GET", error);
  }
};

const getProxyUsers = async () => {
  const suffix = "user/proxyUserList/";
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    },
  });
};

const patchUser = async (patchObj) => {
  const suffix = "user";
  return await fetch(`${url}${suffix}`, {
    method: "PATCH",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    },
    body: JSON.stringify(patchObj)
  });
};

const sendError = async (errorResponse, proxyUserId = undefined) => {
  const suffix = "error/log";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(errorResponse)
  });
};

const getTenantLogo = async (proxyUserId = undefined) => {
  const suffix = "user/tenant-logo";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getTenantMetadata = async (proxyUserId = undefined) => {
  const suffix = "user/tenant-metadata";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getTenantMetadataBySubdomain = async (subdomain) => {
  const suffix = "subdomain/info";
  const headers = APIHeader(undefined, await getAuthToken());
  return await fetch(`${url}${suffix}/${subdomain}`, {
    method: "GET",
    headers: headers
  });
};

const getTenantLogoBySubdomain = async (subdomain) => {
  const suffix = "subdomain/logo";
  const headers = APIHeader(undefined, await getAuthToken());
  return await fetch(`${url}${suffix}/${subdomain}`, {
    method: "GET",
    headers: headers
  });
};

export {
  getAuthToken,
  getUser,
  getProxyUsers,
  patchUser,
  sendError,
  getTenantLogo,
  getTenantMetadata,
  getTenantMetadataBySubdomain,
  getTenantLogoBySubdomain
};